import { useRef } from 'react';
import { useHasOverflow, Chevron } from '@utils/react';
import { useOpgavekompleksetComponent } from '../../../state/context.data.js';
import { useOpgavekompleksetEntry } from '../../../state/hook.entry.js';
import { wrapper, scrollArrow, list } from './_bullets.style.js';
import { Bullet } from './atom.bullet.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const BULLETS_TO_SCROLL_PER_CLICK = 5;
function Bullets() {
  const ref = useRef(null);
  const component = useOpgavekompleksetComponent();
  const [hasOverflow, {
    canScrollLeft,
    canScrollRight
  }] = useHasOverflow(ref);
  const tasks = useOpgavekompleksetEntry({
    select: entry =>
    // NB: For conditional progression we only wish to show tasks that we
    // have visited.
    component.data.settings.progression === "conditional" ? component.data.tasks.filter(task => !!entry?.data.tasks[task.id]) : component.data.tasks
  });
  const handleScrollLeft = () => {
    ref.current?.scrollTo({
      left: ref.current.scrollLeft - BULLETS_TO_SCROLL_PER_CLICK * 28,
      behavior: "smooth"
    });
  };
  const handleScrollRight = () => {
    ref.current?.scrollTo({
      left: ref.current.scrollLeft + BULLETS_TO_SCROLL_PER_CLICK * 28,
      behavior: "smooth"
    });
  };
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    "data-has-overflow": hasOverflow,
    children: [hasOverflow && /*#__PURE__*/jsx("button", {
      className: scrollArrow,
      disabled: !canScrollLeft,
      onClick: handleScrollLeft,
      "aria-hidden": true,
      tabIndex: -1,
      children: /*#__PURE__*/jsx(Chevron, {
        inversed: true,
        size: 10,
        lineWidth: 1.5
      })
    }), /*#__PURE__*/jsx("ul", {
      className: list,
      ref: ref,
      children: tasks?.map(task => /*#__PURE__*/jsx(Bullet, {
        task: task,
        listRef: ref
      }, task.id))
    }), hasOverflow && /*#__PURE__*/jsx("button", {
      className: scrollArrow,
      disabled: !canScrollRight,
      onClick: handleScrollRight,
      "aria-hidden": true,
      tabIndex: -1,
      children: /*#__PURE__*/jsx(Chevron, {
        size: 10,
        lineWidth: 1.5
      })
    })]
  });
}

export { Bullets };
//# sourceMappingURL=_bullets.js.map
